// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"200":"9ec17c06","404":"ca7b10a3","488":"c246135c","715":"3bedabe0","836":"28440456"}[chunkId] + ".js";
};